/* eslint-disable no-unused-vars */
import { Table, Checkbox } from 'antd';
import { Link, NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DokanPageTitle from '../../components/text/DokanPageTitle';
import {
    setSelectedRowKeys,
    fetchOrdersData,
    fetchOrdersSummary,
} from '../../redux/orders/ordersActions';
import DokanExportImportButton from '../../components/button/DokanExportImportButton';
import DokanTableEditDropdown from '../../components/table/DokanTableEditDropdown';
import DokanTableItemPublishedDate from '../../components/table/DokanTableItemStatus/DokanTableItemPublishedDate';
import DokanTablePillTags from '../../components/table/DokanTablePillTags';
import OrdersTable from './OrdersTable';
// eslint-disable-next-line import/named
import DokanIcons from '../../components/icon/DokanIcons';
import OrderFilterByStatus from './OrderFilterByStatus';

function Orders() {
    //     const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const dispatch = useDispatch();
    const { ordersData, selectedRowKeys, ordersSummary } = useSelector((state) => state.orders);
    // const selectedRowKeys = useSelector((state) => state.orders.selectedRowKeys);
    const hasRowKeys = selectedRowKeys.length;
    useEffect(() => {
        dispatch(fetchOrdersData());
        dispatch(fetchOrdersSummary());
    }, [dispatch]);
    // table columns
    const columns = [
        {
            title: 'Order',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => (
                <NavLink
                    exact
                    to={`orders/${record.id}`}
                    className="text-primary hover:text-primary"
                >
                    <div className="text-base text-black font-bold flex gap-3">
                        <div>Order {`${record.id}`}</div>
                        <div>
                            {record.id <= 3 && <DokanIcons icon="#back_order" />}
                            {record.id > 3 && record.id <= 6 && (
                                <DokanIcons icon="#partial_refund" />
                            )}
                            {record.id > 6 && record.id <= 10 && (
                                <DokanIcons icon="#discount" size="4" />
                            )}
                        </div>
                    </div>
                </NavLink>
            ),
        },

        {
            title: 'Order Total',
            dataIndex: 'total',
            key: 'id',
            render: (total, record) => (
                <p className="text-sm text-secondary font-light">{record.total}</p>
            ),
        },
        {
            title: 'Earning',
            dataIndex: 'earning',
            key: 'id',
            render: () => <p className=" text-sm text-secondary font-light">$ 220*</p>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'id',
            render: (status, record) => (
                <DokanTablePillTags variant={record.status}>{record.status}</DokanTablePillTags>
            ),
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'id',
            render: (_, record) => (
                <p className="text-sm text-secondary font-light">{record.customer}</p>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'id',
            render: (date, record) => <DokanTableItemPublishedDate date={date} />,
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'id',
            render: () => <p className="text-sm text-secondary font-light">London*</p>,
        },
        //    {
        //        title: '',
        //        dataIndex: '',
        //        key: 'id',
        //        render: (menu, record) => <DokanTableEditDropdown record={record} />,
        //    },
    ];

    // table custom columns
    const customSelectAll = (e) => {
        dispatch(setSelectedRowKeys([]));
    };
    const onCancel = () => {
        dispatch(setSelectedRowKeys([]));
    };

    // custom Headers events....
    const makeProcessing = () => {
        console.log(selectedRowKeys, 'process');
    };
    const makeOnHold = () => {
        console.log(selectedRowKeys, 'onhold');
    };
    const makeComplete = () => {
        console.log(selectedRowKeys, 'complete');
    };
    const customTableHeader = () => (
        <div className="flex justify-between gap-5 items-center">
            <div>
                <Checkbox
                    onChange={customSelectAll}
                    checked={selectedRowKeys}
                    indeterminate={selectedRowKeys.length < ordersData.length}
                />
            </div>
            <div className="flex-grow-5">
                <div className="flex">
                    <div className="mr-3">
                        <button type="button" onClick={makeProcessing}>
                            make it <strong>Processing</strong>
                        </button>
                    </div>
                    <div className="mr-3">
                        <button type="button" onClick={makeOnHold}>
                            make it <strong>On-hold</strong>
                        </button>
                    </div>
                    <div className="mr-3">
                        <button type="button" onClick={makeComplete}>
                            make it <strong>Completed</strong>
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <button type="button" className="text-red" onClick={onCancel}>
                    <strong>Cancel</strong>
                </button>
            </div>
        </div>
    );

    // table selected rows
    const rowSelection = {
        selectedRowKeys,
        onChange: (_selectedRowKeys, selectedRows) => {
            dispatch(setSelectedRowKeys(_selectedRowKeys));
        },
    };
    return (
        <>
            <div className="min-h-screen container mx-auto py-8 px-12">
                <div className="flex justify-between">
                    <div>
                        <DokanPageTitle>Orders</DokanPageTitle>
                    </div>
                    <div>
                        <DokanExportImportButton />
                    </div>
                </div>
                <div className="mb-8 mt-12">
                    <OrderFilterByStatus ordersSummary={ordersSummary} />
                </div>
                <div className="mt-6">
                    <OrdersTable />
                </div>
            </div>
        </>
    );
}

export default Orders;
